module.exports = __webpack_public_path__ + "assets/ef1e343e50d22e09ea848fc1107651c5.png";